export default {
  production: {
    key: "dependencies",
    title: "Production dependencies",
  },
  peer: {
    key: "peerDependencies",
    title: "Peer dependencies",
  },
  optional: {
    key: "optionalDependencies",
    title: "Optional dependencies",
  },
  bundled: {
    key: [
      "bundledDependencies",
      "bundleDependencies",
    ],
    title: "Bundled dependencies",
  },
  development: {
    key: "devDependencies",
    title: "Development dependencies",
  },
}